import useDiscard from "../core/useDiscard";
import useWeakMap from "../core/utils/useWeakMap";
import { transformObjectToFlat } from "../utils/zone.utils";


const { middlewarePropUIChanges, subcribleOnPropUIChanges } = (() => {
    const propsListener = useWeakMap();

    const initSetListener = (props) => {
        if (!propsListener.has(props)) {
            propsListener.set(props, new Set())
        }
    }

    /**
     * @param {Array<string>} propsDeps
     * @param {object} props
     * @returns {Array<string>}
     */
    const tryExtractPropName = (props, propsDeps = []) => {
        const flat = transformObjectToFlat(props);
        const containProps = [];
        for (let key in flat) {
            for (let i in propsDeps) {
                const target = propsDeps[i];
                if (target.includes(key)) {
                    containProps.push(key);
                } else {
                    containProps.push(target);
                }
            }
        }
        return containProps;
    }

    const emitChanges = (props, propKey) => {
        const listeners = propsListener.get(props);
        if (listeners) {
            listeners.forEach(({ fn, propNameNeedTracking }) => {
                if (propNameNeedTracking === '*' || propNameNeedTracking.has(propKey)) {
                    fn.call(null, propKey);
                }
            })
        }
    }

    const getMiddleWare = () => {
        let _props;

        return {
            injectTo: 'ui',
            callWhen: 'afterChanges',
            injectProps: () => {
                return "*"
            },
            grantProp: (prop) => {
                _props = prop;
                initSetListener(prop)
            },
            provider: {
                setter: (propKey, nextValue, oldValue) => {
                    if (oldValue != nextValue) {
                        emitChanges(_props, propKey);
                    }
                    return nextValue;
                }
            },
            action: {}
        }
    }

    const subcribleOnPropUIChanges = (props, fn, propDeps = [], node) => {
        let unsub = () => { }
        if (false === (propsListener.has(props) && typeof fn === 'function')) {
            return unsub;
        }
        // const propNameNeedTracking = tryExtractPropName(props, propDeps);
        const propNameNeedTracking = propDeps;
        if (propNameNeedTracking.length > 0) {
            const item = {
                fn,
                propNameNeedTracking: new Set(propNameNeedTracking)
            }
            propsListener.get(props).add(item);
            unsub = () => {
                propsListener.get(props).delete(item);
            }
        }
        return unsub
    }

    return {
        middlewarePropUIChanges: getMiddleWare,
        subcribleOnPropUIChanges
    };

})();

export { middlewarePropUIChanges, subcribleOnPropUIChanges }